export enum LoanStatusType_Enum {
  "Quick Quote" = -1,
  Underwriting = 0,
  "Manual Review",
  "Ready To Deal",
  "Unable To Contact",
  "NTU No Contact",
  "NTU Rate Too High",
  "NTU Lost To Competitor",
  "NTU Outside Criteria",
  "NTU Other",
  "Awaiting Payout",
  Completed
}
